import booksUrl from '../components/booktense/books.json?url';
import quotesUrl from '../components/booktense/quotes.json?url';
import { mountExplorer } from '../components/booktense/explorer.js';

/*
 * The data is fetched rather than inlined: Googlebot reads only the first 2MB of
 * an HTML file, and with it inline the page was ~12MB. books.json holds what the
 * chart and the book list need and is itself under that limit, so Google can
 * render them; the quotes are most of the weight and are only needed once a book
 * is opened, so they follow in the background.
 */
const getJson = (url) => fetch(url).then((r) => (r.ok ? r.json() : Promise.reject(new Error(`${r.status} ${url}`))));

getJson(booksUrl)
  .then((data) => {
    const explorer = mountExplorer(data);
    return getJson(quotesUrl).then(explorer.quotesLoaded, (error) => console.error('Book Tense quotes failed to load', error));
  })
  .catch((error) => {
    console.error('Book Tense data failed to load', error);
    document.getElementById('figTitle').textContent = 'The data could not be loaded. Try reloading the page.';
  });
